import { Typography, Stack, Divider } from "@mui/material";


const InventoryList = ({ inventory, showSold }) => {
    if (!inventory?.length) return null;
    return (
        <>
            <Divider sx={{ my: 1 }} />
            <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                Inventory
            </Typography>
            {inventory.map((inv, i) => (
                <Stack key={i} direction="row" justifyContent="space-between" sx={{ py: 0.25 }}>
                    <Typography variant="caption">{inv.productName}</Typography>
                    <Typography variant="caption" color="text.secondary">
                        {showSold ? `${inv.soldQty ?? 0}/${inv.allocatedQty}` : inv.allocatedQty} {inv.unit}
                    </Typography>
                </Stack>
            ))}
        </>
    );
};

export default InventoryList;
